import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AlertEventsTableComponent } from "@app2/alert/alert-shared/alert-events-table.component";
import { SearchSharedModule } from "@app2/search/search-shared/search-shared.module";
import { MlAlertReasonPipe } from "@app2/shared/pipes/mlalert-reason.pipe";
import { MlAlertReasonLinkPipe } from "@app2/shared/pipes/mlalert-reason-link.pipe";
import { SharedModule } from "@app2/shared/shared.module";
import { AlertConditionsInlineComponent } from "@app2/alert/alert-conditions-inline.component";
import { IntervalShortDatePipe } from "@app2/shared/pipes/interval-short-date.pipe";
import { TicketSharedModule } from "@app2/ticket/shared/ticket-shared.module";
import { SequenceTriggerStepsInfoComponent } from "@app2/alert/alert-inbox/sequence-trigger-steps-info.component";
import { SequenceTriggerStepsComponent } from "@app2/alert/sequence-trigger-steps.component";
import { LabelEditSectionComponent } from "@app2/alert/alert-shared/label-edit-section.component";
import { AnomalyCountsComponent } from "@app2/alert/alert-shared/anomaly-counts.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        SharedModule,
        SearchSharedModule,
        TicketSharedModule,
    ],
    declarations: [
        AlertConditionsInlineComponent,
        AlertEventsTableComponent,
        AnomalyCountsComponent,
        IntervalShortDatePipe,
        LabelEditSectionComponent,
        SequenceTriggerStepsComponent,
        SequenceTriggerStepsInfoComponent,
        MlAlertReasonPipe,
        MlAlertReasonLinkPipe,
    ],
    exports: [
        AlertConditionsInlineComponent,
        AlertEventsTableComponent,
        AnomalyCountsComponent,
        IntervalShortDatePipe,
        LabelEditSectionComponent,
        SequenceTriggerStepsComponent,
        SequenceTriggerStepsInfoComponent,
    ],
})
export class AlertSharedModule {
    constructor() {}
}
